<template>
    <transition name="fade">		//动画
        <div class="s-message"
        :class="{'info':type=='info','success':type=='success','warning':type=='warning','danger':type=='danger'}"
         v-show="show"
         :style="{top:top+'px'}">  
            <span class="s-message-info">{{message}}</span>
        </div>
    </transition>
</template>

<script>
export default {
    data(){
        return {
            type:"info",
            top:60
        }
    },
    created(){
        let arr=document.getElementsByClassName('s-message');		//用来控制出现多个提示框往下移动
        this.top=20+this.top*(arr.length)
    },
}
</script>

<style scoped>
.s-message{
    /* min-width:350px; */
    background: #9093B0;
    position: fixed;
    left: 50%;
    line-height: 30px;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    /* margin-left:-175px; */
    z-index: 10000;
    text-align: center;
    padding: 10px 40px;
    border-radius: 8px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: fixed;
    background-color: #FFF;
    -webkit-transition: opacity .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;
    transition: opacity .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s;
    transition: opacity .3s,transform .3s,left .3s,right .3s,top .4s,bottom .3s,-webkit-transform .3s;
    overflow: hidden;
    color: #606266;
}
.s-message-info{
    /* margin-left:10px; */
    color: #fff;
}
.fade-enter-active,.fade-leave-active {
    transition: opacity .3s
}
  .fade-enter,.fade-leave-to{
      opacity: 0
  }
.info{
    background-color:#9093B0
}
.success{
    background-color:#1fdcc6
}
.warning {
    background-color:#F7B752
}
.danger {
    background-color:#F56C6C
}
</style>